import GameVideo from './game_video_view';

export default GameVideo;
